import { useCallback, useState } from 'react';
import { FALLBACK_CONSULTATION_ATTRIBUTES } from './actions';
import { ConsultationAttributesReturnType, IConsultationAttribute } from './types';

// Schema atributelor de consultare e LOCALĂ: BE nu expune `api/surveys/attributes`. Editorul o
// folosește direct; `getAttributes` rămâne pentru compatibilitatea consumatorilor, dar întoarce
// mereu schema locală (fără request de rețea).
export function useConsultationAttributes(
	_getOnRender: boolean | undefined = undefined
): ConsultationAttributesReturnType {
	const [data] = useState<IConsultationAttribute[]>(FALLBACK_CONSULTATION_ATTRIBUTES);

	const getAttributes = useCallback(async () => FALLBACK_CONSULTATION_ATTRIBUTES, []);

	return { data, loading: false, getAttributes };
}
